import {cerrarSesion} from '../utilities/Seguridad'
import axios from 'axios'

const sendAxios = async (config) => {
    let res = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            return error;
        });
    return res;
};

export async function getListaAsistencia(idColegio,idGrado,mes,token) {
 
    let config = {
        method: 'get',
        url: `${process.env.REACT_APP_URL}/asistencia/${idColegio}/${idGrado}/${mes}`,
        headers: { 
          'Authorization': `Bearer ${token}`
        }
      };
      
      const response = await sendAxios(config);
      return response;
} 

export async function registroAsistencia(idColegio,idGrado,mes,asistencias,token) {
 
    let data = new FormData();
    data.append("datos", `${asistencias}`);

    let config = {
        method: 'post',
        url: `${process.env.REACT_APP_URL}/asistencia/${idColegio}/${idGrado}/${mes}`,
        headers: { 
          'Authorization': `Bearer ${token}`
        },
        data : data
      };
      
      const response = await sendAxios(config);
      return response;
} 